import { FeedbackCategory } from '@/types/feedback/FeedbackCategory';
import { ValidationError } from 'class-validator';
import ObjectValidator from '@/types/validation/ObjectValidator';
import getFeedbackTranslationKey from '@/views/feedback/utils/getFeedbackTranslationKey';
import i18next from 'i18next';

export default class Feedback {
  public name: string = '';
  public email: string = '';
  public category?: FeedbackCategory;
  public content: string = '';

  public constructor() {}

  public validate(): ValidationError[] {
    const validator = new ObjectValidator();
    const validators = [];
    validators.push(
      validator.isEmptyValidator(this.name, 'feedbackformular.name', 'feedbackformular.validation.name.isEmpty')
    );
    validators.push(
      validator.isEmptyValidator(this.email, 'feedbackformular.email', 'feedbackformular.validation.email.isEmpty')
    );
    validators.push(
      validator.isEmailInValid(this.email, 'feedbackformular.email', 'feedbackformular.validation.email.isNotAEMail')
    );
    validators.push(
      validator.isEmptyValidator(
        this.category,
        'feedbackformular.category',
        'feedbackformular.validation.category.isEmpty'
      )
    );
    validators.push(
      validator.isEmptyValidator(this.content, 'feedbackformular.text', 'feedbackformular.validation.content.isEmpty')
    );
    return validator.validate(validators);
  }

  public getJSONData() {
    return {
      name: this.name,
      email: this.email,
      category: i18next.t(getFeedbackTranslationKey(this.category)),
      content: this.content,
    };
  }
}
